export default {"src":"/_next/static/media/play.0e715b43.svg","height":90,"width":73,"blurWidth":0,"blurHeight":0};